import type { TownData, TownResidentSnapshot } from '@/modules/game-domain/world.types';

/** Replace presentation only; saved geometry and interaction identities stay intact. */
export function applyTownResidentSnapshots(towns: TownData[], updates: readonly TownResidentSnapshot[]): TownData[] {
  let changed = false;
  const next = towns.map(town => {
    const controllerId = town.biome === 'road' ? -town.id : town.id;
    let presentation = town.npcPresentation;
    for (const update of updates) {
      if (update.townId !== controllerId || update.revision !== town.authored?.layoutHash) continue;
      const incoming = update.presentation?.runtime, previous = presentation?.runtime;
      if (!incoming || !Number.isFinite(incoming.serverTimeMs) || !Number.isFinite(incoming.sequence)) continue;
      if (previous && (incoming.serverTimeMs < previous.serverTimeMs || incoming.serverTimeMs === previous.serverTimeMs && incoming.sequence <= previous.sequence)) continue;
      presentation = structuredClone(update.presentation);
    }
    if (presentation === town.npcPresentation) return town;
    changed = true;
    return { ...town, npcPresentation: presentation };
  });
  return changed ? next : towns;
}

/** Only accepted presentations can advance the rendering clock. */
export function townResidentServerTime(towns: readonly TownData[]): number {
  return towns.reduce((latest, town) => Math.max(latest, town.npcPresentation?.runtime?.serverTimeMs ?? 0), 0);
}
